/**
 * 嘗試修復「UTF-8 檔名被錯誤當成 Latin-1 顯示」所造成的亂碼（mojibake）。
 * 例如：`1ä¸...` 應該是 `1上...`
 *
 * 注意：若後端已經把原始檔名破壞，前端只能做「顯示修復」，無法真正還原所有情況。
 */
export const maybeFixUtf8Mojibake = (input: string): string => {
  const s = String(input ?? '');
  if (!s) return s;

  // 已包含常見 CJK 字元就不處理（避免誤轉）
  if (/[\u4e00-\u9fff]/.test(s)) return s;

  // 沒有任何「常見亂碼指標」也不處理（避免對英文檔名做多餘轉換）
  // 例：ä¸ / å° / é 頁 等
  if (!/[ÃÄÅÆÇÐÑÖØÜÝÞßãäåæçðñöøüýþÿåéèêëíìîïóòôõöúùûü]/.test(s)) {
    return s;
  }

  try {
    const bytes = Uint8Array.from(s, c => c.charCodeAt(0) & 0xff);
    const decoded = new TextDecoder('utf-8', { fatal: false }).decode(bytes);

    // 若解碼結果反而出現替換字元或變成空白，回退原字串
    if (!decoded || decoded.includes('�')) return s;
    return decoded;
  } catch {
    return s;
  }
};
